import React from 'react';
import { Link } from 'react-router-dom';
import { Wind, Mail, Phone, MapPin, Linkedin, Twitter, Github } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <Wind className="logo-icon" />
              <span className="logo-text">Turbo Algorithms</span>
            </div>
            <p className="footer-description">
              Revolutionary single-blade VAWT technology with cloud-optimised algorithms. 
              Delivering profitable distributed energy at global scale.
            </p>
            <div className="footer-contact">
              <div className="contact-item">
                <MapPin size={16} />
                <span>308 North Road, Yate, Bristol, BS37 7LL, UK</span>
              </div>
              <div className="contact-item">
                <Phone size={16} />
                <span>+44 7576 884014</span>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <span>chris.turner.cycom@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Technology Links */}
          <div className="footer-section">
            <h3 className="footer-title">Technology</h3>
            <ul className="footer-links">
              <li><Link to="/technology">VAWT Design</Link></li>
              <li><Link to="/technology">Carbon Fibre Construction</Link></li>
              <li><Link to="/technology">Control Systems</Link></li>
              <li><Link to="/technology">Cloud Optimization</Link></li>
              <li><Link to="/platform">Live Platform</Link></li>
            </ul>
          </div>

          {/* Solutions Links */}
          <div className="footer-section">
            <h3 className="footer-title">Solutions</h3>
            <ul className="footer-links">
              <li><Link to="/calculator">ROI Calculator</Link></li>
              <li><Link to="/">Distributed Energy</Link></li>
              <li><Link to="/">Agricultural Operations</Link></li>
              <li><Link to="/">Commercial Buildings</Link></li>
              <li><Link to="/">Industrial Sites</Link></li>
            </ul>
          </div>

          {/* Company Links */}
          <div className="footer-section">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-links">
              <li><Link to="/investors">Investors</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/">About Us</Link></li>
              <li><Link to="/">Careers</Link></li>
              <li><Link to="/">Press Kit</Link></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <span>&copy; 2026 Turbo Algorithms Wind Turbine Design. All rights reserved.</span>
            <div className="footer-legal-links">
              <Link to="/">Privacy Policy</Link>
              <Link to="/">Terms of Service</Link>
              <Link to="/">Cookie Policy</Link>
            </div>
          </div>
          <div className="footer-social">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <Linkedin size={20} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <Twitter size={20} />
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <Github size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
